import { PATH_APP } from "../paths";
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import AuthProtect from "src/components/Auth/AuthProtect";
import DashboardLayout from "src/layouts/DashboardLayout";

// ----------------------------------------------------------------------

const UserRoutes = {
  path: PATH_APP.user.root,
  guard: AuthProtect,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      role: [],
      path: PATH_APP.user.account,
      component: lazy(() => import("src/views/user/AccountView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.subsSuccess,
      component: lazy(() => import("src/views/user/AccountView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.subsCancel,
      component: lazy(() => import("src/views/user/AccountView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.subsCancelSuccess,
      component: lazy(() => import("src/views/user/AccountView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.contact,
      component: lazy(() => import("src/views/user/ContactPage")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.audit,
      component: lazy(() => import("src/views/user/AuditView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.tpvActivity,
      component: lazy(() => import("src/views/user/TpvActivityView")),
    },
    {
      exact: true,
      role: [],
      // 2026-10-27 · «Errores Hacienda» pasa a «Auditoría Hacienda»; la URL
      // antigua sigue funcionando y muestra la misma vista.
      path: PATH_APP.user.aeatAudit,
      component: lazy(() => import("src/views/user/AeatAuditView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.aeatErrors,
      component: lazy(() => import("src/views/user/AeatAuditView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.employeeCorrections,
      component: lazy(() => import("src/views/user/EmployeeCorrectionsView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.myPortal,
      component: lazy(() => import("src/views/user/MyPortalView")),
    },
    {
      exact: true,
      role: [],
      path: PATH_APP.user.root,
      component: () => <Redirect to={PATH_APP.user.account} />,
    },
    {
      component: () => <Redirect to="/404" />,
    },
  ],
};

export default UserRoutes;
